import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const reasons = ['Garantía de 5 años después de la construcción', 'Contratos ante notaría para mayor respaldo', 'Presupuestos totalmente gratis', 'Atención directa por WhatsApp', 'Presentación clara de servicios y trabajos realizados', 'Enfoque en confianza, seriedad y cumplimiento'];
export function WhyChooseUs() {
  return <section className="py-20 bg-navy text-white" data-id="element-171">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-172">
        <div className="max-w-4xl mx-auto" data-id="element-173">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-174">
            Por qué trabajar con nosotros
          </motion.h2>

          <div className="grid sm:grid-cols-2 gap-x-12 gap-y-6" data-id="element-175">
            {reasons.map((reason, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start gap-4" data-id="element-176">
                <CheckCircle2Icon className="w-6 h-6 text-orange shrink-0 mt-0.5" data-id="element-177" />
                <p className="text-lg text-gray-300" data-id="element-178">{reason}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}